import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../utils/store';
import { clearAuth } from '../../utils/store/auth/AuthSlice';
import AuthRoute from './AuthRoute';

interface SignupRouteProps {
  children: JSX.Element;
}

// An employer signup link (/signup?employer_id=...) is for a new user, so it must always open
// the signup page. A session left in the browser (often expired) would otherwise send the user
// to /dashboard and, after its 401, on to /login. Without employer_id it behaves like AuthRoute.
const SignupRoute: React.FC<SignupRouteProps> = ({ children }) => {
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();
  const token = useSelector((state: RootState) => state.auth.token);
  const isEmployerLink = new URLSearchParams(location.search).has('employer_id');

  useEffect(() => {
    if (isEmployerLink && token) {
      dispatch(clearAuth());
    }
  }, [isEmployerLink, token, dispatch]);

  if (isEmployerLink) {
    return children;
  }
  return <AuthRoute>{children}</AuthRoute>;
};

export default SignupRoute;
